<div class="home__popularproduct__container">
  <div
    class="popularproduct__header"
    [class.popularproduct__header--stack-mobile]="stackHeaderOnMobile"
    [class.popularproduct__header--no-title]="!showTitle">
    <div *ngIf="showTitle" class="popularproduct__heading">
      <h2 class="popularproduct__heading-title">{{ titleKey | translate }}</h2>
    </div>
    <ng-content select="[product-filter]"></ng-content>
    <a *ngIf="showViewAll" routerLink="/product" [queryParams]="viewAllQueryParams" class="popularproduct__header-link">
      {{ 'common.view_all' | translate }}
      <mat-icon class="popularproduct__header-link-icon" aria-hidden="true">arrow_forward</mat-icon>
    </a>
  </div>

  <div *ngIf="loading" class="popularproduct__status" role="status">
    <mat-spinner [diameter]="32" aria-hidden="true"></mat-spinner>
    <span>{{ 'home.design.loading' | translate }}</span>
  </div>
  <div *ngIf="!loading && emptyMessageKey && !popularProduct?.length" class="popularproduct__status" role="status">
    {{ emptyMessageKey | translate }}
  </div>
  <ng-content select="[product-status]"></ng-content>
  <div class="popularproduct__item__container" [class.popularproduct__item__container--grid]="mobileGrid" [attr.aria-busy]="loading">
    <div
      *ngFor="let item of popularProduct"
      class="popularproduct__item"
      (click)="onSelectProduct(item.product.slug || item.product.id)"
    >
      <div class="popularproduct__image" [class.is-out-of-stock]="isOutOfStock(item)">
        <div class="cnh-badge" *ngIf="showCustomizationBadge && item.product.hasCustomization">
          <svg class="cnh-icon" viewBox="0 0 24 24" width="11" height="11" fill="currentColor" aria-hidden="true">
            <path d="M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10c1.38 0 2.5-1.12 2.5-2.5 0-.61-.23-1.21-.64-1.67-.08-.1-.13-.21-.13-.33 0-.28.22-.5.5-.5H16c3.31 0 6-2.69 6-6 0-4.96-4.49-9-10-9zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 8 6.5 8s1.5.67 1.5 1.5S7.33 11 6.5 11zm3-4c-.83 0-1.5-.67-1.5-1.5S8.67 4 9.5 4s1.5.67 1.5 1.5S10.33 7 9.5 7zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 4 14.5 4s1.5.67 1.5 1.5S15.33 7 14.5 7zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 8 17.5 8s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
          </svg>
          <span class="cnh-text">CNH</span>
        </div>

        <button
          class="favorite-btn"
          [class.active]="isFavorite(item.product.id)"
          (click)="toggleWishlist(item.product.id, $event)"
          [attr.aria-label]="'home.popular.add_wishlist' | translate"
        >
          <svg class="heart-icon" viewBox="0 0 24 24" aria-hidden="true">
            <path
              d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5
         2 5.42 4.42 3 7.5 3
         9.24 3 10.91 3.81 12 5.08
         13.09 3.81 14.76 3 16.5 3
         19.58 3 22 5.42 22 8.5
         22 12.28 18.6 15.36 13.45 19.99z"
            />
          </svg>
        </button>

        <img
          *ngIf="getMainProductImageUrl(item) && !brokenImageIds.has(item.product.id)"
          [appLazyImg]="getMainProductImageUrl(item)"
          (imageError)="onImageError(item.product.id)"
          [alt]="item.product.name"
        />
        <div *ngIf="!getMainProductImageUrl(item) || brokenImageIds.has(item.product.id)" class="no-product-image" aria-hidden="true">
          <span class="material-symbols-outlined">inventory_2</span>
        </div>

        <div class="out-of-stock-overlay" *ngIf="isOutOfStock(item)">
          <span class="out-of-stock-label">{{ 'PRODUCT_LIST.ACTIONS.OUT_OF_STOCK' | translate }}</span>
        </div>

        <button class="popularproduct__design__btn" (click)="goToCustomize(item, $event)" *ngIf="item.product.hasCustomization && !isOutOfStock(item)">
          <span class="material-symbols-outlined">colors</span>
          {{ 'home.popular.go_design' | translate }}
        </button>
      </div>
      <div class="popularproduct__info__container">
        <div class="popularproduct__info">
          <div class="popularproduct__title">{{ item.product.name }}</div>
          
          <div class="popularproduct__meta" *ngIf="(item.product.averageRating && item.product.averageRating > 0) || (item.product.soldQuantity && item.product.soldQuantity > 0)">
            <div class="meta-item popularproduct__rating" *ngIf="item.product.averageRating && item.product.averageRating > 0">
              <span class="star-icon">★</span>
              <span class="rating-value">{{ item.product.averageRating | number : '1.1-1' }}</span>
              <span class="rating-count" *ngIf="item.product.totalReviews">({{ item.product.totalReviews }})</span>
            </div>
            <div class="meta-item popularproduct__sold" *ngIf="item.product.soldQuantity && item.product.soldQuantity > 0">
              {{ formatSold(item.product.soldQuantity) }}
            </div>
          </div>

          <div class="popularproduct__price-group">
            <div class="popularproduct__price">
              <span class="price__current">{{
                getProductPrice(item) | currency : "VND" : "symbol" : "1.0-0" : "vi"
              }}</span>
            </div>
            <div
              class="popularproduct__moq"
              *ngIf="showMoqBadge"
              [class.is-bulk]="getMinQuantity(item) > 1"
            >
              {{
                (getMinQuantity(item) === 1
                  ? 'home.design.card_moq_badge_single'
                  : 'home.design.card_moq_badge'
                ) | translate : { count: getMinQuantity(item) }
              }}
            </div>
          </div>
        </div>
        <div class="add__to__cart" [class.disabled]="isOutOfStock(item)"
          [attr.aria-disabled]="isOutOfStock(item)"
          [attr.title]="isOutOfStock(item) ? ('PRODUCT_LIST.ACTIONS.OUT_OF_STOCK' | translate) : ('common.cart' | translate)"
          (click)="onQuickAddToCart(item, $event)">
          <img class="cart__icon" src="assets/icons/bag.svg" [alt]="'common.cart' | translate" />
        </div>
      </div>
    </div>
  </div>
  <div class="popularproduct__bottom" *ngIf="showViewAll">
    <a routerLink="/product" [queryParams]="viewAllQueryParams" class="popularproduct__view-all">
      {{ 'common.view_all' | translate }} <span class="material-symbols-outlined">arrow_right_alt</span>
    </a>
  </div>
</div>
